import React from 'react';
import styles from './FooterBlock.module.css';
import { InstagramSvg, TelegramSvg } from '../../SVGComponents/SVGComponents';
export default function FooterBlock() {
  return (
    <div className={styles.container}>
      <div className={styles.title}>Контакти</div>
      <div className={styles.links_wrapper}>
        <div className={styles.links_block}>
          <div className="mb_15">
            <a
              href="https://t.me/+380968513108"
              target="_blank"
              className="h30 hover active activeClick dif aic gap_10"
              rel="noopener noreferrer">
              <TelegramSvg />
              <span className={styles.link_text}>Телеграм</span>
            </a>
          </div>
          <div className="mb_15">
            <a
              href="https://www.instagram.com/natalya_kylish"
              target="_blank"
              className="h30 hover active activeClick dif aic gap_10"
              rel="noopener noreferrer">
              <InstagramSvg />
              <span className={styles.link_text}>Інстаграм</span>
            </a>
          </div>
          <div className="mb_15">
            <span className={styles.link_title}>Тел: </span>
            <a
              href="tel:+380968513108"
              className={styles.call_btn + ' ' + 'hover active activeClick'}>
              <span className={styles.link_text}>096 851 31 08</span>
            </a>
          </div>
        </div>
        <div className={styles.links_block}>
          <div className="mb_15">
            <span className={styles.link_title}>Сайт: </span>
            <a
              href="https://nk.vinnica.ua"
              target="_blank"
              className={styles.call_btn + ' ' + 'hover active activeClick'}>
              <span className={styles.link_text}>nk.vinnica.ua</span>
            </a>
          </div>
          <div className="mb_15">
            <span className={styles.link_title}>Програма: </span>
            <a
              href="https://app.nk.vinnica.ua"
              target="_blank"
              className={styles.call_btn + ' ' + 'hover active activeClick'}>
              <span className={styles.link_text}>app.nk.vinnica.ua</span>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
